<div class="visualizer-container">

  <div class="chart-wrapper"
       [class.cursor-grab]="!isDragging"
       [class.cursor-grabbing]="isDragging"
       (mousedown)="startDrag($event)">

    <canvas baseChart
            #chartCanvas
            [datasets]="scatterChartDatasets"
            [options]="scatterChartOptions"
            [plugins]="scatterChartPlugins"
            [legend]="false"
            [chartType]="'scatter'">
    </canvas>

    <!-- RESET BUTTON (Uses custom .reset-btn-container class) -->
    <div class="reset-btn-container">
      <button *ngIf="hasUserPanned"
              class="btn btn-sm btn-white shadow-sm d-flex align-items-center gap-2 animate-up"
              (click)="resetView()"
              (mousedown)="$event.stopPropagation()">
        <i class="fa fa-compress-arrows-alt"></i>
        <span>Reset View</span>
      </button>
    </div>

    <!-- LEGEND (Uses custom .legend-overlay class defined in CSS) -->
    <div *ngIf="fileStats.length > 0"
         class="legend-overlay rounded shadow-sm"
         [class.collapsed]="!isLegendExpanded">

      <!-- Header -->
      <div class="legend-header d-flex justify-content-between align-items-center p-3 cursor-pointer"
           (click)="toggleLegend(); $event.stopPropagation()"
           (mousedown)="$event.stopPropagation()">

        <h6 class="text-uppercase text-muted fw-bold mb-0" style="font-size: 0.75rem; letter-spacing: 1px;">
          <i class="fa fa-file-alt me-1"></i> Sources
        </h6>

        <!-- Note: Using 'fa-chevron-up' logic -->
        <i class="fa" [ngClass]="isLegendExpanded ? 'fa-chevron-up' : 'fa-chevron-down'" style="font-size: 0.8rem; color: #94a3b8;"></i>
      </div>

      <!-- Body -->
      <div class="legend-body p-3 pt-2" *ngIf="isLegendExpanded" (mousedown)="$event.stopPropagation()">

        <div class="d-flex justify-content-end mb-2" *ngIf="activeFileFilter">
          <button class="btn btn-xs btn-outline-secondary py-0 px-2"
                  style="font-size: 0.7rem;"
                  (click)="$event.stopPropagation(); activeFileFilter = null; updateChartVisuals()">
            Clear Filter
          </button>
        </div>

        <div class="legend-items">
          <div *ngFor="let stat of fileStats"
               class="legend-item d-flex align-items-center mb-2 cursor-pointer p-1 rounded"
               [class.active-filter]="activeFileFilter === stat.name"
               [class.dimmed]="activeFileFilter && activeFileFilter !== stat.name"
               (click)="onLegendClick(stat.name); $event.stopPropagation()"
               (mouseenter)="onLegendHover(stat.name)"
               (mouseleave)="onLegendLeave()">

            <div class="legend-color rounded-circle me-2" [style.background-color]="stat.color"></div>
            <div class="flex-grow-1" style="min-width: 0;">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="file-name" [title]="stat.name">{{ stat.name }}</span>
                <span class="file-count">{{ stat.count }}</span>
              </div>
              <div class="progress" style="height: 3px; background-color: #e2e8f0;">
                <div class="progress-bar" [style.width.%]="stat.percentage" [style.background-color]="stat.color"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- View Details Button (Centered Bottom) -->
    <div class="position-absolute bottom-0 start-50 translate-middle-x m-3" style="z-index: 1000;">
      <button *ngIf="selectedNodeId" class="btn btn-dark shadow-lg rounded-pill px-4 animate-up" (click)="requestOpenModal()">
        View Details <i class="fa fa-arrow-right ms-2"></i>
      </button>
    </div>
  </div>
</div>
